import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class FormTaskApi extends BaseApi {
    constructor(client, basePath = '/form-task') {
        super(client, basePath);
    }

    /**
     * Get tasks waiting for assignment (admin/manager only)
     */
    async getWaiting(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/waiting`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Get tasks assigned to current user
     */
    async getMyTasks(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/my-tasks`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** Görev Merkezi (myWork izni) — şablona bağlı görevler */
    async getMyWorkInbox(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/my-work-inbox`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async saveSurveyDraft(taskId, data) {
        try {
            const response = await this.client.put(`${this.basePath}/${taskId}/survey-draft`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async submitSurveyResponse(taskId, data) {
        try {
            const response = await this.client.put(`${this.basePath}/${taskId}/survey-submit`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Assign a task to a user
     */
    async assign(taskId, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${taskId}/assign`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Complete a task
     */
    async complete(taskId, data = {}) {
        try {
            const response = await this.client.put(`${this.basePath}/${taskId}/complete`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
